import { useState } from 'react'
import { Flex, UnstyledButton } from '@mantine/core'
import { useDebouncedCallback } from '@mantine/hooks'

import type { UserSelectProps } from '@/modules/advisors/users/pages/chat/components/UserSelect/UserSelect.types'
import { UsersList } from '@/modules/advisors/users/pages/chat/components/UsersList/UsersList'

import { TextInput } from '@/components/TextInput/TextInput'

import CloseIcon from '@/assets/icons/close.svg?react'

import classes from './UserSelect.module.css'

export function UserSelect({
  isLoading,
  onUserSearch,
  onUserSelect,
  searchedUser,
  selectedUserId,
  users,
}: UserSelectProps) {
  const [localSearch, setLocalSearch] = useState<string>(searchedUser)

  const handleDebouncedSearch = useDebouncedCallback((value: string) => {
    if (value.length < 3 && value.length > 0) return
    onUserSearch(value)
  }, 500)

  return (
    <Flex className={classes.container} direction="column">
      <TextInput
        autoComplete="off"
        onChange={e => {
          setLocalSearch(e.target.value)
          handleDebouncedSearch(e.target.value)
        }}
        placeholder="Search (min. 3 characters)"
        rightSection={
          localSearch && (
            <UnstyledButton
              className={classes.inputClear}
              onClick={() => {
                setLocalSearch('')
                onUserSearch('')
              }}
            >
              <CloseIcon />
            </UnstyledButton>
          )
        }
        spellCheck="false"
        styles={{
          input: {
            paddingRight: 32,
          },
        }}
        value={localSearch}
      />

      <UsersList
        isLoading={isLoading}
        onUserSelect={onUserSelect}
        selectedUserId={selectedUserId}
        users={users}
      />
    </Flex>
  )
}
